import Carousel from "@/components/ui/carousel/carousel";
import React from "react";
import { SwiperSlide } from "swiper/react";
import Image from "next/image";
export default function Products() {
  const images = [
    "/images/Dashboard.webp",
    "/images/Initiative Application.webp",
    "/images/Respondent Registration.webp",
  ];
  const breakpoints = {
    1280: {
      slidesPerView: 3,
      spaceBetween: 30,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
    },
    991: {
      slidesPerView: 3,
      spaceBetween: 20,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
    },
    // when window width is >= 768px
    768: {
      slidesPerView: 2.5,
      spaceBetween: 20,
      slidesOffsetBefore: 32,
      slidesOffsetAfter: 32,
    },
    325: {
      slidesPerView: 1.8,
      spaceBetween: 15,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
    },
  };
  return (
    <div className="w-full flex flex-col pb-20 bg-[#fafafa] lg:px-16">
      <div className="lg:max-w-[1080px] mx-auto w-full">
        <Carousel
          slidesPerView={3}
          spaceBetween={30}
          loop={false}
          className="featureCarousel w-full my-8"
          breakpoints={breakpoints}
          navigation={false}
          //   autoplay={{
          //     delay: 4500,
          //     disableOnInteraction: false,
          //   }}
          mousewheel={{
            forceToAxis: true,
            sensitivity: 1,
            releaseOnEdges: true,
          }}
          showNavAbove={false}
        >
          {images.map((image, key) => (
            <SwiperSlide key={"product" + key}>
              <div className="relative w-full h-[500px]">
                <Image
                  src={image}
                  alt={"product"}
                  sizes="(max-width: 479px) 500px, 800px"
                  fill
                  className="w-full h-full object-contain object-center"
                />
              </div>
            </SwiperSlide>
          ))}
        </Carousel>
      </div>
    </div>
  );
}
